export class CancelTrigger {
  private container: CancelTriggers;

  private triggered = false;
  private readonly callback: () => void;

  private triggerPromise = () => {};
  readonly whenCanceled: Promise<void>;

  get canceled() {
    return this.triggered;
  }

  constructor(callback: () => void, container: CancelTriggers) {
    this.callback = callback;
    this.container = container;

    this.whenCanceled = new Promise((resolve) => {
      this.triggerPromise = resolve;
    });
  }

  trigger() {
    this.triggered = true;

    this.callback();
    this.triggerPromise();
  }

  remove() {
    this.container.remove(this);
  }
}

export class CancelTriggers {
  private triggers: CancelTrigger[] = [];

  createCancelTrigger(callback = () => {}) {
    const result = new CancelTrigger(callback, this);

    this.triggers.push(result);
    return result;
  }

  remove(trigger: CancelTrigger) {
    this.triggers = this.triggers.filter((t) => t !== trigger);
  }

  public trigger() {
    for (const trigger of this.triggers) {
      trigger.trigger();
    }

    this.triggers = [];
  }
}
